import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';

const routes = [
  {
    path: '/',
    component: () => import('@/layouts/DefaultLayout.vue'),
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'Home',
        component: () => import('@/views/public/HomePage.vue'),
        meta: { requiresAuth: false }
      },
      {
        path: '/products',
        name: 'Products',
        component: () => import('@/views/public/ProductsPage.vue'),
        meta: { requiresAuth: false }
      },
      {
        path: '/product/:id',
        name: 'ProductDetail',
        component: () => import('@/views/public/ProductDetailPage.vue'),
        meta: { requiresAuth: false }
      },
      {
        path: '/cart',
        name: 'Cart',
        component: () => import('@/views/public/CartPage.vue'),
        meta: { requiresAuth: false }
      },
      {
        path: '/checkout',
        name: 'Checkout',
        component: () => import('@/views/public/CheckoutPage.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/public/LoginPage.vue'),
        meta: { requiresAuth: false, guestOnly: true }
      },
      {
        path: '/register',
        name: 'Register',
        component: () => import('@/views/public/RegisterPage.vue'),
        meta: { requiresAuth: false, guestOnly: true }
      },
      {
        path: '/profile',
        name: 'Profile',
        component: () => import('@/views/user/ProfilePage.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/orders',
        name: 'Orders',
        component: () => import('@/views/user/OrdersPage.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/orders/:id',
        name: 'OrderDetail',
        component: () => import('@/views/user/OrderDetailPage.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/addresses',
        name: 'Addresses',
        component: () => import('@/views/user/AddressesPage.vue'),
        meta: { requiresAuth: true }
      },
    ]
  },
  // ADMIN ROUTES - Faqat admin uchun
  {
    path: '/manager',
    component: () => import('@/layouts/AdminLayout.vue'),
    meta: { requiresAuth: true, requiresAdmin: true },
    redirect: '/manager/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'AdminDashboard',
        component: () => import('@/views/admin/AdminDashboardPage.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'products',
        name: 'AdminProducts',
        component: () => import('@/views/admin/AdminProductsPage.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'categories',
        name: 'AdminCategories',
        component: () => import('@/views/admin/AdminCategoriesPage.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'all-sold-products',
        name: 'AllSoldProducts',
        component: () => import('@/views/admin/pos/AllSoldProducts.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },

      {
        path: 'point-of-sail',
        name: 'PointOfSail',
        component: () => import('@/views/admin/pos/POSSystem.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },

      {
        path: 'credit-sale-management',
        name: 'credit-sale-management',
        component: () => import('@/views/admin/pos/CreditSalesManagement.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },

      {
        path: 'orders',
        name: 'AdminOrders',
        component: () => import('@/views/admin/AdminOrdersPage.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'users',
        name: 'AdminUsers',
        component: () => import('@/views/admin/AdminUsersPage.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      }
    ]
  },

  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/public/NotFoundPage.vue'),
    meta: { requiresAuth: false }
  }

];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
        top: 70
      };
    } else {
      return { top: 0 };
    }
  }
});

// Auth Guard
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin);
  const guestOnly = to.matched.some(record => record.meta.guestOnly);
  const isAuthenticated = store.getters['auth/isAuthenticated'];
  const user = store.state.auth.user;
  const isAdmin = user && user.role === 'admin';

  // Auth required
  if (requiresAuth && !isAuthenticated) {
    next({ name: 'Login', query: { redirect: to.fullPath } });
  }
  // Guest only pages (login/register)
  else if (guestOnly && isAuthenticated) {
    // Agar user admin bo'lsa admin dashboardga, aks holda home ga
    if (isAdmin) {
      next({ name: 'AdminDashboard' });
    } else {
      next({ name: 'Home' });
    }
  }
  // Admin required
  else if (requiresAdmin && !isAdmin) {
    next({ name: 'Home' });
  }
  else {
    next();
  }
});

export default router;